import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=75aea24e&scoped=true&"
import script from "./TextWidget.vue?vue&type=script&lang=js&"
export * from "./TextWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aea24e",
  null
  
)

export default component.exports